import { render, staticRenderFns } from "./customerManagement.vue?vue&type=template&id=a5f1705c&scoped=true&"
import script from "./customerManagement.vue?vue&type=script&lang=ts&"
export * from "./customerManagement.vue?vue&type=script&lang=ts&"
import style0 from "./customerManagement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customerManagement.vue?vue&type=style&index=1&id=a5f1705c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f1705c",
  null
  
)

export default component.exports